'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest$0024$002dFrom$002dParents from "./app.data.-App-Document-Lineage-Request$-From-Parents.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageRequest$FromParents$() {
}
export { $c_Lapp_data_AppDocumentLineageRequest$FromParents$ as $c_Lapp_data_AppDocumentLineageRequest$FromParents$ };
$p = $c_Lapp_data_AppDocumentLineageRequest$FromParents$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentLineageRequest$FromParents$;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageRequest$FromParents$() {
}
export { $h_Lapp_data_AppDocumentLineageRequest$FromParents$ as $h_Lapp_data_AppDocumentLineageRequest$FromParents$ };
$h_Lapp_data_AppDocumentLineageRequest$FromParents$.prototype = $p;
$p.n = (function() {
  return "FromParents";
});
$p.bKt = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest$0024$002dFrom$002dParents.$c_Lapp_data_AppDocumentLineageRequest$FromParents(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKt(p);
});
var $d_Lapp_data_AppDocumentLineageRequest$FromParents$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentLineageRequest$FromParents$, "app.data.AppDocumentLineageRequest$FromParents$", ({
  Cj: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentLineageRequest$FromParents$ as $d_Lapp_data_AppDocumentLineageRequest$FromParents$ };
var $n_Lapp_data_AppDocumentLineageRequest$FromParents$;
function $m_Lapp_data_AppDocumentLineageRequest$FromParents$() {
  if ((!$n_Lapp_data_AppDocumentLineageRequest$FromParents$)) {
    $n_Lapp_data_AppDocumentLineageRequest$FromParents$ = new $c_Lapp_data_AppDocumentLineageRequest$FromParents$();
  }
  return $n_Lapp_data_AppDocumentLineageRequest$FromParents$;
}
export { $m_Lapp_data_AppDocumentLineageRequest$FromParents$ as $m_Lapp_data_AppDocumentLineageRequest$FromParents$ };
//# sourceMappingURL=app.data.-App-Document-Lineage-Request$-From-Parents$.js.map
